export const navigation = [
  {
    nome: "Medalhas",
    icone: "mdi-medal",
    path: "/",
  },
  {
    nome: "Locais dos Eventos",
    icone: "mdi-pin",
    path: "/venues",
  },
  {
    nome: "Esportes",
    icone: "mdi-run",
    path: "/disciplines",
  },
  {
    nome: "Jogos/Eventos",
    icone: "mdi-torch",
    path: "/events",
  },
];
